module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp123_0.f65a529a.png";